
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/grid",
      function () {
        return require("private-next-pages/system/grid.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/grid"])
      });
    }
  